import { render, staticRenderFns } from "./tenant-settings.vue?vue&type=template&id=a51ab1b2&scoped=true"
import script from "./tenant-settings.vue?vue&type=script&lang=ts"
export * from "./tenant-settings.vue?vue&type=script&lang=ts"
import style0 from "./tenant-settings.vue?vue&type=style&index=0&id=a51ab1b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51ab1b2",
  null
  
)

export default component.exports